module.exports = __webpack_public_path__ + "img/mengHu5.672e9225.png";